'use strict';

class SpellsView {
    constructor($scope, $http, $uibModal) {
        this.$scope = $scope;
        this.$http = $http;
        this.$uibModal = $uibModal;

        this.filter = {bylevels: "flat", class: "", lang: "ru", archetype: ""};
        this.curclass = null;
        this.search = "";
        this.schools = [
            {
                En: "Abjuration",
                Ru: "Ограждение"
            },
            {
                En: "Conjuration",
                Ru: "Призыв"
            },
            {
                En: "Divination",
                Ru: "Прорицание"
            },
            {
                En: "Enchantment",
                Ru: "Очарование"
            },
            {
                En: "Evocation",
                Ru: "Воплощение"
            },
            {
                En: "Illusion",
                Ru: "Иллюзия"
            },
            {
                En: "Necromancy",
                Ru: "Некромантия"
            },
            {
                En: "Transmutation",
                Ru: "Преобразование"
            }
        ];

        $scope.orderSpells = (spell)=>{
            return this.filter.lang === 'ru' ? spell.Ru.Name : spell.En.Name;
        };
        $scope.filterFunction = (spell)=>{
            return spell.Ru.Name.toLowerCase().includes(this.search.toLowerCase()) || spell.En.Name.toLowerCase().includes(this.search.toLowerCase())
        };

        this.filtering();
    }

    filtering() {
        console.log('run filtering');
        this.$http({
            url: "/api/spells/" + this.filter.bylevels + (this.filter.class ? "/" + this.filter.class + (this.filter.archetype ? "/" + this.filter.archetype : "") : ""),
            method: "get"
        }).then(
            (resp) => {
                console.log(resp);
                this.data = resp.data.payload;
                this.curclass = null;
                this.data.classes.forEach((item) => {
                    if (this.filter.class === item.id) {
                        this.curclass = item;
                        this.curclass.archetypes.push({id: "", runame: "Нет", enname: "None"})
                    }
                });
            },
            (err) => {
                console.log(err);
            }
        )

    }

    open(size, id) {

        return this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'spell.html',
            controller: 'ModalInstanceCtrl',
            controllerAs: '$ctrl',
            size: size,
            resolve: {
                one:
                    () => {
                        return this.$http({
                            url: "/api/spells/get/" + id,
                            method: "get"
                        });
                    },
                lang: () => {
                    return this.filter.lang;
                }
            }
        });
    }

}

SpellsView.$inject = ['$scope', '$http', '$uibModal'];
export {SpellsView};